import React from 'react';
import classNames from 'classnames';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import CardSettingsMenu from './CardSettingsMenu';
import styles from './styles.module.css';
import CardLayoutEditorController from '../controllers/CardLayoutEditorController';
import { upperFirst } from 'lodash';
import { AhaButton } from 'components/common/reactifyWebComponent';

const CardSettings = () => {
  const controller = useController(CardLayoutEditorController);
  const { activeCardView, cardViews } = controller.state;

  const cardViewButtons =
    cardViews.length > 1
      ? cardViews.map(cardView => (
          <AhaButton
            key={cardView}
            active={activeCardView === cardView}
            onClick={() => controller.actionSetCardView(cardView)}
          >
            {upperFirst(cardView)} view
          </AhaButton>
        ))
      : null;

  return (
    <div className={classNames('px-8 py-2', styles.cardSettings)}>
      {cardViewButtons ? (
        <aha-button-group>{cardViewButtons}</aha-button-group>
      ) : (
        // Need a spacer div for flexbox space-between
        <div />
      )}
      <CardSettingsMenu />
    </div>
  );
};

export default view(CardSettings);
